export default __webpack_public_path__ + "static/cta-pescatarian-1-7f45668c2e1ba184cf34bc3865fa5880.jpg";